import {createFileRoute} from '@tanstack/react-router';

import MedicationRequestDelete from '@/practitioner/views/medicationRequest/MedicationRequestDelete';

export const Route = createFileRoute(
  '/(practitioner)/practitioner/medication-requests/$medicationRequestId/delete'
)({
  component: MedicationRequestDelete,
  loader: ({params}) => ({
    medicationRequestId: params.medicationRequestId
  })
});
